import {
  Button,
  MultiSelectDropDown,
  SelectDropDown,
} from '@/components/Common';

import { TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import { FieldError } from 'react-hook-form';
import { useAddTest } from '@/pages/BlankExam/SettingUpTests/useAddTest';
import { ExerciseOutput } from '@/api/gql/graphql';
import { useEffect, useState } from 'react';
import { Options } from '@/components/Common/Selects/Select.types';

export type AddTestProps = {
  selectedExercise: ExerciseOutput | null;
};

export const AddTest = ({ selectedExercise }: AddTestProps) => {
  const {
    isOpenExamModal,
    editingTab,
    series,
    disciplines,
    handleCloseModal,
    handleChangeSeries: handleChangeSeriesFromHook,
    handleCreateExercise,
    handleUpdateExercise,
    register,
    handleSubmit,
    errors,
    setValue,
    selectedDiscipline,
    setSelectedDiscipline,
    selectedSeries,
    setSelectedSeries,
  } = useAddTest({ id: selectedExercise?._id });

  useEffect(() => {
    if (selectedExercise) {
      setValue('name', selectedExercise.name);
      setValue('position', selectedExercise.position);
      setValue('duration', Number(selectedExercise.duration));

      if (selectedExercise.discipline) {
        const discipline = {
          _id: selectedExercise.discipline._id,
          name: selectedExercise.discipline.name,
        };
        setSelectedDiscipline(discipline);
        setValue('subject', discipline._id);
      }

      if (selectedExercise.series) {
        const series = selectedExercise.series.map((serie) => ({
          _id: serie._id,
          name: serie.name,
        }));
        setSelectedSeries(series);
        setValue('series', series);
      }
    }
  }, [selectedExercise, setValue]);

  const handleChangeDiscipline = (value: Options) => {
    setSelectedDiscipline(value);
    if (value._id) {
      setValue('subject', String(value._id), { shouldValidate: true });
    }
  };

  const handleChangeSeries = (values: Options[]) => {
    setSelectedSeries(values);
    const formattedOptions = values.map((option) => ({
      _id: String(option._id || ''),
      name: String(option.name || ''),
    }));
    setValue('series', formattedOptions, { shouldValidate: true });
    handleChangeSeriesFromHook(values);
  };

  return (
    <Modal
      isOpen={isOpenExamModal}
      onClose={handleCloseModal}
      modalStyle="bg-bgModal"
      headerStyle="bg-bgModal h-[36px]"
    >
      <form
        onSubmit={handleSubmit(
          editingTab ? handleUpdateExercise : handleCreateExercise,
        )}
      >
        <div className="w-[315px]">
          <h1 className="mb-5 text-[20px] font-bold text-center text-white">
            {editingTab ? "Modifier l'Epreuve" : 'Nouvelle Epreuve'}
          </h1>

          <TextField
            className="mb-0 placeholder:text-iconColor placeholder:text-sm placeholder:px-4 !bg-almostBlack"
            register={register('name')}
            placeholder="Nom de l'Epreuve"
            helpText={(errors.name as FieldError)?.message}
            errorStyle="!text-red-500"
            textFieldType={TextfieldType.INPUT}
            type={TextfieldType.INPUT}
          />
          <TextField
            className="mb-0 placeholder:text-iconColor placeholder:text-sm placeholder:px-4 !bg-almostBlack"
            register={register('position')}
            placeholder="Position"
            helpText={(errors.position as FieldError)?.message}
            errorStyle="!text-red-500"
            textFieldType={TextfieldType.INPUT}
            type={TextfieldType.INPUT}
          />
          <SelectDropDown
            className=" placeholder:text-sm placeholder:pl-[60px] placeholder:text-red-700 bg-red-700"
            placeholder="Subject"
            name="subject"
            setValue={setValue}
            helpText={(errors.subject as FieldError)?.message}
            errorStyle="text-red-500"
            options={disciplines || []}
            initialSelectedOptions={selectedDiscipline}
            handleChange={handleChangeDiscipline}
          />

          <div className="flex items-center gap-2 mb-5 mt-3">
            <MultiSelectDropDown
              options={series ? series : []}
              handleChange={handleChangeSeries}
              setValue={setValue}
              initialSelectedOptions={selectedSeries}
              name="series"
              placeholder="Série"
              helpText={(errors.series as FieldError)?.message}
              errorStyle="text-red-500"
            />
          </div>
          <TextField
            className="mb-0 placeholder:text-iconColor placeholder:text-sm placeholder:px-4 !bg-almostBlack"
            register={register('duration')}
            placeholder="Durée en minutes"
            helpText={(errors.duration as FieldError)?.message}
            errorStyle="!text-red-500"
            textFieldType={TextfieldType.INPUT}
            type="number"
          />
        </div>
        <Button
          type="submit"
          title={editingTab ? 'Modifier' : 'Ajouter'}
          className="w-full mt-10"
        />
      </form>
    </Modal>
  );
};
